var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCloseV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "black",
    stroke: "current",
    fillOpacity: 0.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.535 6.22734L8.76147 8.00022L10.535 9.77311C10.5851 9.82314 10.6247 9.88253 10.6518 9.9479C10.6789 10.0133 10.6928 10.0833 10.6928 10.1541C10.6928 10.2248 10.6789 10.2949 10.6518 10.3602C10.6247 10.4256 10.5851 10.485 10.535 10.535C10.485 10.5851 10.4256 10.6247 10.3602 10.6518C10.2949 10.6789 10.2248 10.6928 10.1541 10.6928C10.0833 10.6928 10.0133 10.6789 9.94789 10.6518C9.88253 10.6247 9.82314 10.5851 9.77311 10.535L8.00022 8.76147L6.22734 10.535C6.17731 10.5851 6.11792 10.6247 6.05255 10.6518C5.98719 10.6789 5.91713 10.6928 5.84638 10.6928C5.77563 10.6928 5.70557 10.6789 5.6402 10.6518C5.57484 10.6247 5.51544 10.5851 5.46542 10.535C5.41539 10.485 5.3757 10.4256 5.34863 10.3602C5.32155 10.2949 5.30762 10.2248 5.30762 10.1541C5.30762 10.0833 5.32155 10.0133 5.34863 9.9479C5.3757 9.88253 5.41539 9.82314 5.46542 9.77311L7.23897 8.00022L5.46542 6.22734C5.36438 6.1263 5.30762 5.98927 5.30762 5.84638C5.30762 5.70349 5.36438 5.56645 5.46542 5.46542C5.56645 5.36438 5.70349 5.30762 5.84638 5.30762C5.98927 5.30762 6.1263 5.36438 6.22734 5.46542L8.00022 7.23897L9.77311 5.46542C9.82314 5.41539 9.88253 5.3757 9.94789 5.34863C10.0133 5.32155 10.0833 5.30762 10.1541 5.30762C10.2248 5.30762 10.2949 5.32155 10.3602 5.34863C10.4256 5.3757 10.485 5.41539 10.535 5.46542C10.5851 5.51545 10.6247 5.57484 10.6518 5.6402C10.6789 5.70557 10.6928 5.77563 10.6928 5.84638C10.6928 5.91713 10.6789 5.98719 10.6518 6.05255C10.6247 6.11792 10.5851 6.17731 10.535 6.22734Z",
    fill: "#F4F4F4",
    stroke: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCloseV2);
export default __webpack_public_path__ + "static/media/circle-closeV2.6d225ba24ee946d14fc7737f59cb1103.svg";
export { ForwardRef as ReactComponent };